<!-- eslint-disable vue/return-in-computed-property -->
<template>
  <!-- 计划信息卡片 -->
  <div class="cartItem" @click.stop>
    <div class="shopTitle fvlrw">
      <h4>服务合约</h4>
      <span v-if="isDeabled">商品或车辆信息改变,请重新选择</span>
    </div>
    <BaseCard :data="baseData">
      <template #Ifn>
        <p>
          <span class="priceNum"> ¥{{ data.price }} </span>
          <span class="priceWord">零售价*</span>
        </p>
        <div @click.stop>
          <van-stepper :disabled="isEWProduct" v-model="buyAmountNum" integer button-size="20" :max="buyAmountLimit" disable-input @change="changeNum" />
        </div>
      </template>
    </BaseCard>
  </div>
</template>

<script>
import { reactive, toRefs, inject, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { updateShoppingInf } from '@/api/shoppingCar'
import { setConfirmGoodsStore } from '@/util/shoppingCar/handle'
import BaseCard from '@/components/directSales/BaseCard'

import { Toast } from 'vant'
import _ from 'lodash'
export default {
  components: {
    BaseCard
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  setup(props, { emit }) {
    const router = useRouter()
    const store = useStore()
    let { data } = toRefs(props)
    let addShowNum = inject('addShowNum')
    let calculateTotalNum = inject('calculateTotalNum')
    const state = reactive({
      data: data.value,
      buyAmountNum: data.value.num
    })
    const changeNum = _.debounce(async v => {
      calculateTotalNum()
      if (v >= buyAmountLimit.value && v > 0 && buyAmountLimit.value > 0) {
        Toast({
          message: '该商品已达到最大购买数量',
          position: 'bottom'
        })
      }
      if (v < 1) {
        v = 1
        state.buyAmountNum = v
      }
      const { id, customerCarId, delStatusFlag, gsCode, productId, productType } = state.data._data
      const param = Object.assign({ id, customerCarId, delStatusFlag, gsCode, productId, productType }, { productQuantity: v })
      emit('changeNum', v)
      try {
        await updateShoppingInf(param)
      } catch (e) {
        console.error(e.message || '数据修改失败')
        Toast({
          message: e.message || '数据修改失败',
          position: 'bottom'
        })
      }
    }, 200)
    const toDetail = data => {
      const { productType, productId, gsCode } = data._data
      // let path = ''
      // let query = {}
      // if (productType == 1) {
      //   // 设置数据到vuex
      //   setConfirmGoodsStore(store, Object.assign({}, data._data, { imgSrc: data.imgSrc }))
      //   // 计划跳往计划详情
      //   path = '/planDetail'
      //   query = { loyaltyId: productId, from: 'shoppingCarList', event: '查看致友计划详情' }
      // }
      // if (productType === 2) {
      //   // 计划跳往轮胎详情
      //   path = '/tyreDetail'
      //   query = { tyreId: productId, gsCode, event: '查看轮胎详情' }
      // }
      // nextTick(() => {
      //   path && router.push({ path, query })
      // })
    }

    const isDeabled = computed(() => state.data._data.changedFlag && state.data._data.productType === 3)
    const isEWProduct = computed(() => state.data.isEW)
    const baseData = computed(() => {
      return {
        thumbnail: state.data.imgSrc,
        productName: state.data.productName,
        productNames: state.data.productNames,
        dealerName: state.data.dealerName,
        carText: state.data.carInf
      }
    })
    // eslint-disable-next-line vue/return-in-computed-property
    const buyAmountLimit = computed(() => {
      const { buyAmountLimit } = state.data._data
      if (isEWProduct.value) {
        return 0
      }
      if (isDeabled.value) {
        // changeNum(0)
        // return 0
      } else {
        return buyAmountLimit > -1 ? buyAmountLimit : 9999
      }
    })
    return {
      ...toRefs(state),
      addShowNum,
      changeNum,
      toDetail,
      buyAmountLimit,
      isDeabled,
      isEWProduct,
      baseData
    }
  }
}
</script>
<style lang="scss" scoped>
.cartItem {
  // display: inline-block;
  width: calc(100% - 20px);
  // font-size: 12px;
}
.shopTitle {
  margin-bottom: 10px;
  h4 {
    font-weight: 500;
    color: #333;
    font-size: 15px;
  }
  span {
    color: #999;
    font-size: 13px;
  }
  border-bottom: 1px solid #eee;
}
.priceNum {
  font-size: 14px;
  font-weight: 600;
  color: #3088c5;
}
.priceWord {
  margin-left: 18px;
  font-size: 14px;
  color: #666;
}
</style>
